// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mp-feed-container {
    position: relative;
    width: 100%;
    max-width: 800px;
    height: auto;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    border-radius: 10px;
    gap: 10px;
  }

  .mp-user-feed {
    position: relative;
    font-family: Switzer;
    font-size: 25px;
    height: auto;
    max-width: 100%;
    width: auto;
    background-color: none;
    display: flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    box-shadow: 2px 2px 2px 2px whitesmoke;
    gap: 5px;
    flex-direction: column;
  }

  .mp-feed-header {
    min-height: 10px;
    height: auto;
    width: 60%;
    font-size: 18px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background:none;
    color: black;
    gap: 20; 
  }

  .mp-user-action-container {
    height: 40px;
    font-family: Switzer;
    font-size: 16px;
    display: flex;
    width: 100%;
    background: none;
    flex-direction: row;
  }
    
  .mp-user-container {
    width: 100%;
    background: none;
    height: 50px;
    position: "relative";
    display: flex;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  .mp-feed-media {
    font-family: Switzer;
    font-size: 18px;
    height: auto;
    width: auto;
    text-align: left;
    margin: 10px 0;
    background: none;
  }

  .mp-media-img {
    width: 700px;
    border-radius: 8px;
    padding: 10px;
  }

  .mp-media-video {
    width: 900px;
    border-radius: 8px;
  }

  .mp-feed-comments {
    background: rgb(153, 145, 145);
    border-radius: 10px;
    font-family: Switzer;
    font-size: 20px;
    height: 150px;
  }

  .mp-comments {
    margin-top: 0px;
    background-color: rgb(196, 185, 185);
    border-radius: 10px;
    font-family: Switzer;
    font-size: 20px;
    color: rgb(20, 13, 13);
    height: 40px;
    overflow-y: scroll;
  }

  .mp-post-card {
    height: auto;
    width: auto;
    border-radius: 10px;
    gap: 20px;
    background: none;
    box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);
  }

    /* Main Feed */
.mp-main-feed {
    /* background-color: rgb(245, 238, 238); */
    margin-top: 10px;
    /* border-radius: 10px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1); */
}

.mp-add-comment {
  width: 98%;
  height: 40px; /* Set a fixed height */
  display: flex;
  align-items: flex-end; /* Aligns both input and button at the bottom */
 /* background-color: #1f1f1f;*/
  gap: 10px;
  border-radius: 20px;
  margin: 10px;
  justify-content: space-between;
}

.mp-comment-input {
  margin-left: -10px;
  flex-grow: 1; /* Ensures input takes up the remaining space */
  width: 70%;
}

.mp-add-comment .mp-comment-input {
  background-color:#605a5a;;
  color: white; /* Ensure text is readable */
  border: 1px solid #444; /* Optional: Add a border for better visibility */
  border-radius: 10px;
  outline: none; /* Remove default outline */
  width: 100%;

}

.mp-add-comment .mp-comment-input::placeholder {
  color: #bbb; /* Adjust placeholder text color */
}


.mp-add-comment-button {
  width: 20%; /* Allow the button to adjust based on content */
  height: inherit;
  margin-right: -5px;
  background-color:#2f2c2c;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.2s ease;
}


.mp-add-comment-button:hover {
  background-color: #3c3d3d;
  transform: scale(1.1);
}



/* Scrollbar Styling */
.mp-comments-list::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
 
}

.mp-comments-list::-webkit-scrollbar-thumb {
  background-color: #3c3d3d; /* Color of the scrollbar */
  border-radius: 5px; /* Rounded scrollbar edges */
  margin-top: 7px;
}

.mp-comments-list::-webkit-scrollbar-track {
  background-color: #2f2c2c; /* Background of scrollbar track */
 /* border-radius: 5px;*/
}

.mp-text-header {
  font-size: 30px;
}

.mp-text-label {
  font-family: "Switzer";
  font-size: 18px;
  align-self: "right";
  margin-top: 4px;
}

.mp-post-stats-right {
  display: inline-block;
  width: 100%;
  text-align: right;
  font-size: 16px;
  margin-right: -10px;
}

.mp-post-stats-left {
  display: flax;
  flex-direction: row;
  gap: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/MemberProfileFetchData.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,sCAAsC;IACtC,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,mJAAmJ;IACnJ,eAAe;IACf,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mJAAmJ;EACrJ;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,0CAA0C;EAC5C;;IAEE,cAAc;AAClB;IACI,0CAA0C;IAC1C,gBAAgB;IAChB;kDAC8C;AAClD;;AAEA;EACE,UAAU;EACV,YAAY,EAAE,uBAAuB;EACrC,aAAa;EACb,qBAAqB,EAAE,+CAA+C;CACvE,8BAA8B;EAC7B,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,+CAA+C;EAC7D,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,YAAY,EAAE,4BAA4B;EAC1C,sBAAsB,EAAE,iDAAiD;EACzE,mBAAmB;EACnB,aAAa,EAAE,2BAA2B;EAC1C,WAAW;;AAEb;;AAEA;EACE,WAAW,EAAE,kCAAkC;AACjD;;;AAGA;EACE,UAAU,EAAE,gDAAgD;EAC5D,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2DAA2D;AAC7D;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;;AAIA,sBAAsB;AACtB;EACE,UAAU,EAAE,2BAA2B;;AAEzC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB,EAAE,4BAA4B;EAChD,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;CAC9D,uBAAuB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EAErB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".mp-feed-container {\n    position: relative;\n    width: 100%;\n    max-width: 800px;\n    height: auto;\n    background-color: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    border-radius: 10px;\n    gap: 10px;\n  }\n\n  .mp-user-feed {\n    position: relative;\n    font-family: Switzer;\n    font-size: 25px;\n    height: auto;\n    max-width: 100%;\n    width: auto;\n    background-color: none;\n    display: flex;\n    align-items: left;\n    justify-content: left;\n    border-radius: 10px;\n    box-shadow: 2px 2px 2px 2px whitesmoke;\n    gap: 5px;\n    flex-direction: column;\n  }\n\n  .mp-feed-header {\n    min-height: 10px;\n    height: auto;\n    width: 60%;\n    font-size: 18px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    background:none;\n    color: black;\n    gap: 20; \n  }\n\n  .mp-user-action-container {\n    height: 40px;\n    font-family: Switzer;\n    font-size: 16px;\n    display: flex;\n    width: 100%;\n    background: none;\n    flex-direction: row;\n  }\n    \n  .mp-user-container {\n    width: 100%;\n    background: none;\n    height: 50px;\n    position: \"relative\";\n    display: flex;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  }\n\n  .mp-feed-media {\n    font-family: Switzer;\n    font-size: 18px;\n    height: auto;\n    width: auto;\n    text-align: left;\n    margin: 10px 0;\n    background: none;\n  }\n\n  .mp-media-img {\n    width: 700px;\n    border-radius: 8px;\n    padding: 10px;\n  }\n\n  .mp-media-video {\n    width: 900px;\n    border-radius: 8px;\n  }\n\n  .mp-feed-comments {\n    background: rgb(153, 145, 145);\n    border-radius: 10px;\n    font-family: Switzer;\n    font-size: 20px;\n    height: 150px;\n  }\n\n  .mp-comments {\n    margin-top: 0px;\n    background-color: rgb(196, 185, 185);\n    border-radius: 10px;\n    font-family: Switzer;\n    font-size: 20px;\n    color: rgb(20, 13, 13);\n    height: 40px;\n    overflow-y: scroll;\n  }\n\n  .mp-post-card {\n    height: auto;\n    width: auto;\n    border-radius: 10px;\n    gap: 20px;\n    background: none;\n    box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);\n  }\n\n    /* Main Feed */\n.mp-main-feed {\n    /* background-color: rgb(245, 238, 238); */\n    margin-top: 10px;\n    /* border-radius: 10px;\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1); */\n}\n\n.mp-add-comment {\n  width: 98%;\n  height: 40px; /* Set a fixed height */\n  display: flex;\n  align-items: flex-end; /* Aligns both input and button at the bottom */\n /* background-color: #1f1f1f;*/\n  gap: 10px;\n  border-radius: 20px;\n  margin: 10px;\n  justify-content: space-between;\n}\n\n.mp-comment-input {\n  margin-left: -10px;\n  flex-grow: 1; /* Ensures input takes up the remaining space */\n  width: 70%;\n}\n\n.mp-add-comment .mp-comment-input {\n  background-color:#605a5a;;\n  color: white; /* Ensure text is readable */\n  border: 1px solid #444; /* Optional: Add a border for better visibility */\n  border-radius: 10px;\n  outline: none; /* Remove default outline */\n  width: 100%;\n\n}\n\n.mp-add-comment .mp-comment-input::placeholder {\n  color: #bbb; /* Adjust placeholder text color */\n}\n\n\n.mp-add-comment-button {\n  width: 20%; /* Allow the button to adjust based on content */\n  height: inherit;\n  margin-right: -5px;\n  background-color:#2f2c2c;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: bold;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n\n.mp-add-comment-button:hover {\n  background-color: #3c3d3d;\n  transform: scale(1.1);\n}\n\n\n\n/* Scrollbar Styling */\n.mp-comments-list::-webkit-scrollbar {\n  width: 8px; /* Width of the scrollbar */\n \n}\n\n.mp-comments-list::-webkit-scrollbar-thumb {\n  background-color: #3c3d3d; /* Color of the scrollbar */\n  border-radius: 5px; /* Rounded scrollbar edges */\n  margin-top: 7px;\n}\n\n.mp-comments-list::-webkit-scrollbar-track {\n  background-color: #2f2c2c; /* Background of scrollbar track */\n /* border-radius: 5px;*/\n}\n\n.mp-text-header {\n  font-size: 30px;\n}\n\n.mp-text-label {\n  font-family: \"Switzer\";\n  font-size: 18px;\n  align-self: \"right\";\n  margin-top: 4px;\n}\n\n.mp-post-stats-right {\n  display: inline-block;\n  margin-right: 10px;\n  width: 100%;\n  text-align: right;\n  font-size: 16px;\n  margin-right: -10px;\n}\n\n.mp-post-stats-left {\n  display: flax;\n  flex-direction: row;\n  gap: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
